
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLightIconSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 3.5v1.75M18.364 5.636l-1.237 1.237M20.5 12h-1.75M18.364 18.364l-1.237-1.237M5.636 5.636l1.237 1.237M3.5 12h1.75M5.636 18.364l1.237-1.237",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M15.5 11.25a3.5 3.5 0 1 0-7 0c0 1.45.88 2.691 2.15 3.25v1.75c0 .414.336.75.75.75h1.2a.75.75 0 0 0 .75-.75V14.5c1.27-.559 2.15-1.8 2.15-3.25Z",
  stroke: "#000",
  strokeWidth: 1.5
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 19h3",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\r\n  <path d=\"M12 3.5V5.25\" stroke=\"#000000\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\r\n  <path d=\"M18.364 5.636L17.127 6.873\" stroke=\"#000000\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\r\n  <path d=\"M20.5 12H18.75\" stroke=\"#000000\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\r\n  <path d=\"M18.364 18.364L17.127 17.127\" stroke=\"#000000\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\r\n  <path d=\"M5.636 5.636L6.873 6.873\" stroke=\"#000000\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\r\n  <path d=\"M3.5 12H5.25\" stroke=\"#000000\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\r\n  <path d=\"M5.636 18.364L6.873 17.127\" stroke=\"#000000\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\r\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.5 11.25C15.5 9.317 13.933 7.75 12 7.75C10.067 7.75 8.5 9.317 8.5 11.25C8.5 12.7 9.38 13.941 10.65 14.5V16.25C10.65 16.664 10.986 17 11.4 17H12.6C13.014 17 13.35 16.664 13.35 16.25V14.5C14.62 13.941 15.5 12.7 15.5 11.25Z\" stroke=\"#000000\" stroke-width=\"1.5\"/>\r\n  <path d=\"M10.5 19H13.5\" stroke=\"#000000\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/light-icon-small.8550e455adb851f48393c84a8bb62e25.svg"),
        {
          React: SvgLightIconSmall,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      